export const API = {
    dipmal: `/dipmal`,
    communications: `/communications`,
    support: `/support`,
    typesall: `/typesall`,
    dimension: `/dimension`,
    public: `/public`,
    donor: `/donor`,
    contents: `/contents`,
    customer: `/customer`,
    customers: `/customers`,
    documents: `/documents`,
    structure: `/structure`,
    forms: `/forms`,
    signedUrl: `/signed-url`,
    config: `/campaign/config`,
    preRestorePwd: `/pre-restore-pwd`,
    donations: `/donations`,
    donation: `/donation`,
    draft: `/draft`,
    whats: `/whats`,
    search: `/search`,
    id: `/id`,
    catalogs: `/catalogs`,
    status: `/status`,
    reuse: `/reuse`,
    appVersions: `/app-versions`,
};